// extracted by mini-css-extract-plugin
export var animateCircle = "modal-module--animate-circle--QTkSJ";
export var body = "modal-module--body--Rowao";
export var bounce = "modal-module--bounce--H-jeV";
export var close = "modal-module--close--YjUzE";
export var content = "modal-module--content--8C-Vx";
export var ldsRing = "modal-module--lds-ring--QuN95";